/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM, displayTypes, centerAbsolutely } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// AD STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	uniquecontent: {
		background: 'rgba(17,17,17,.9)',
		transition: 'background .5s linear 0s'
	}
};
